import React, { useState } from "react";

type RowContextType = {
  headerColId: string;
  setHeaderColId: React.Dispatch<React.SetStateAction<string>>;
};

export const RowContext = React.createContext<RowContextType | undefined>(
  undefined
);

type RowContextProps = {
  children: React.ReactNode;
};

export const RowProvider = ({ children }: RowContextProps): JSX.Element => {
  const [headerColId, setHeaderColId] = useState<string>("");

  const value = { headerColId, setHeaderColId };
  return <RowContext.Provider value={value}>{children}</RowContext.Provider>;
};

export const useRow = (): RowContextType | never => {
  const context = React.useContext(RowContext);

  if (context === undefined) {
    throw new Error("useRow must be used within a RowProvider");
  }

  return context;
};
